export const enum Step {
    UPLOAD,
    SHARE,
    DOWNLOAD_APP,
    ACHIEVEMENT,
}

export const StepName: Record<Step, string> = {
    [Step.UPLOAD]: 'upload',
    [Step.SHARE]: 'share',
    [Step.DOWNLOAD_APP]: 'download_app',
    [Step.ACHIEVEMENT]: 'achievement',
};

export interface CurrentStepActionParams {
    step: Step;
    isOpen?: boolean;
}

export interface ShareHintStepParams {
    itemId: string;
}

export interface OnboardingState {
    isOpen: boolean;
    isVisible: boolean;
    isInitialized: boolean;
    currentStepIndex: number;
    hints: {
        upload: boolean;
        shareButtonId: string | null;
        download: boolean;
        subscription: boolean;
    };
}
